import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AnalyticsService from '../services/analytics';

/**
 * Custom hook to track page views automatically on route change.
 */
const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        AnalyticsService.trackPageView(location.pathname + location.search);
    }, [location]);
};

export default usePageTracking;
